import translations from '../../../translations/app-translations.json';

export const refreshOrderNotifyEP = (error, locale, toastr) => {
    if (error && error.response && error.response.body && error.response.body.error) {
        toastr.error(translations[locale].error, error.response.body.error);
    } else {
        toastr.error(translations[locale]['error-refresh-order-title'], translations[locale]['error-refresh-order-content'], {
            timeOut: 60000,
        });
    }
};

export default { refreshOrder: refreshOrderNotifyEP };



/** WEBPACK FOOTER **
 ** ./src/errors/processors/refresh-order.js
 **/